export type ModerationProfileStatus = 'approved' | 'rejected' | 'pending';

export interface ModerationProfileBase {
  id: string;
  profile_user_id?: string;
  trust_score: number;
  status: ModerationProfileStatus;
  images: string[];
  bio?: string;
  prompts?: Array<{ question?: string; answer?: string }>;
  metadata?: Record<string, unknown>;
  image_results?: Array<{ passed: boolean }>;
  text_results?: { score: number };
  created_at: string;
  name?: string;
  age?: number;
  sex?: string;
  occupation?: string;
  location?: string;
}

export const PROFILE_DETAIL_FIELDS: { key: keyof ModerationProfileBase | 'profile_user_id'; label: string }[] = [
  { key: 'name', label: 'Name' },
  { key: 'age', label: 'Age' },
  { key: 'sex', label: 'Sex' },
  { key: 'occupation', label: 'Occupation' },
  { key: 'location', label: 'Location' },
  { key: 'profile_user_id', label: 'User ID' },
];
